<template>
  <div class="platformOnline">
    <NewHeader></NewHeader>
    <!-- 标题 -->
    <div class="institution-title">
      <!-- <img :src="insTitleImg" alt /> -->
      <HeadTitle></HeadTitle>
    </div>
    <div class="navigation">
      <span class="color-blue" @click="$router.push({path:'/'})">首页</span>
      <span
        class="cur-pointer color-blue"
        @click="toHengFengPage"
        v-show="isChildPage"
      >&nbsp;/&nbsp;横峰县副中心</span> &nbsp;/
      &nbsp;平台注册专家
    </div>
    <div class="content" v-loading="loading">
      <!-- <div class="content-title">{{titleTxt}}医学影像平台注册专家</div> -->
      <div class="show-items">
        <!-- 医生列表 -->
        <div
          class="doc-item cur-pointer"
          v-for="(item, index) in tableDatas[curPage]"
          :key="item.DOCTOR_ID"
          @click="toExpDetail(item.DOCTOR_ID)"
        >
          <!-- 头像 -->
          <div class="doc-head">
            <!-- <img src="../assets/img/index/doc1.png" alt /> -->
            <img
              :src="item.DOC_PHOTO"
              alt
              @error="docNoError(item,'DOC_PHOTO')"
              class="cur-pointer"
            />
          </div>
          <!-- 基本信息 -->
          <div class="doc-info">
            <div class="doc-name">
              <span>{{ item.DOC_NAME }}</span>
              <span>{{ item.DOC_TITLE }}</span>
            </div>
            <div class="color-66 text-over" :title="item.HOS_ID + ' ' + item.DEPT_ID">
              <span>{{ item.HOS_NAME }}</span>
              <span>{{ item.DEPT_NAME }}</span>
            </div>
            <div class="color-99">
              <span>已签约医院：&nbsp;</span>
              <span class="color-41CB8C">{{ item.signOrganCount }}</span>
            </div>
          </div>
          <!-- 会诊数据 -->
          <div class="doc-data color-99">
            <div>
              <span>会诊总数：&nbsp;</span>
              <span class="color-43A4DF">{{ item.writeCount }}</span>
            </div>
            <div>
              <span>总回退数：&nbsp;</span>
              <span class="color-FE6670">{{ item.backCount }}</span>
            </div>
            <div>
              <span>总超时数：&nbsp;</span>
              <span class="color-7795E6">{{ item.overtimeCount }}</span>
            </div>
          </div>
        </div>
        <div class="page-list">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :hide-on-single-page="value"
            :page-size="10"
            layout=" prev, pager, next, total"
            :total="totalPageCount"
          ></el-pagination>
        </div>
      </div>
    </div>

    <NewFooter></NewFooter>
  </div>
</template>

<script>
import NewHeader from '../components/NewHeader.vue'
import HeadTitle from '../components/HeadTitle.vue'
import NewFooter from '../components/NewFooter.vue'
import docNo from '../assets/img/index/doc1.png'
export default {
  name: 'platformOnline',
  data() {
    return {
      insTitleImg: require('../assets/img/regInstitution/hengfeng_title.png'), // 标题图片
      tableDatas: [],
      tableTotal: {}, // 合计
      titleTxt: '上饶市',
      isChildPage: false,
      totalPageCount: 0,
      currentPage: 1,
      value: false,
      loading: true,
      curPage: 0
    }
  },
  components: {
    NewHeader,
    HeadTitle,
    NewFooter
  },

  methods: {
    docNoError(d, name) {
      //图片error处理
      d[name] = docNo
    },

    // element 分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },
    handleCurrentChange(val) {
      let that = this
      let params = that.setParams(true)
      that.curPage = val -1
    },

    // 设置参数
    setParams(page) {
      let that = this
      let params = new URLSearchParams()
      let province = that.$route.query.province
      let city = that.$route.query.city
      let area = that.$route.query.area
      // let organ_id = that.$route.query.organ_id

      if (province !== undefined && province !== '') {
        that.ifShowPlatform = false
        that.areatitle = '横峰县'
        that.isChildPage = true

        params.append('province', province)
        params.append('city', city)
        params.append('area', area)
        // params.append('HOSPITAL_ID', organ_id)
      } else {
        that.ifShowPlatform = true
        that.areatitle = '上饶市'
        that.isChildPage = false
        params = new URLSearchParams()
      }
      if (page) {
        // for (let key in obj) {
        params.append('currentPage', that.currentPage)
        // }
      }
      return params
    },

    // 设置 router 的 params 参数

    setQueryParams() {
      let that = this
      let params = {}
      params.province = that.$route.query.province
      params.city = that.$route.query.city
      params.area = that.$route.query.area
      // params.HOSPITAL_ID = that.$route.query.organ_id
      return params
    },

    // 跳转副中心:
    toHengFengPage() {
      let that = this
      let params = that.setQueryParams()
      that.$router.push({ path: '/', query: params })
    },

    // 获取表格数据
    getTableDatas() {
      let that = this
      let params = that.setParams(true)
      params.append("HOSPITAL_ID", that.$route.query.organ_id);
      // let data = {}
      // data.HOSPITAL_ID = that.$route.query.organ_id
      that.$ajax
        .post('homePage/queryExpertDetailList', params)
        .then(response => {
          console.log(response)
          if (response.result) {
            // that.tableDatas = response.expList
            that.loading = false
            console.log(that.tableDatas)

            // 分页设置
            that.totalPageCount = response.expList.length
            var defaultExpList = response.expList
            var newExpList = []

            // 前端分页
            for (let i = 0; i < defaultExpList.length; i += 10) {
              var dataItem = defaultExpList.slice(i, i + 10)
              newExpList.push(dataItem)
            }
            that.tableDatas = newExpList


          }
        })
        .catch(error => {})
    },
    setTitleTxt() {
      let that = this
      if (
        that.$route.query.province != '' &&
        that.$route.query.province != undefined
      ) {
        that.titleTxt = '横峰县'
      } else {
        that.titleTxt = '上饶市'
      }
    },

    // 跳转医生详情
    toExpDetail(docId) {
      console.log(docId)
      let that = this
      that.$router.push({ path: '/docIndex', query: { id: docId } })
    }
  },
  created() {
    this.setTitleTxt()
    this.getTableDatas()
  },
  watch: {}
}
</script>


<style lang="stylus">
.color-66 {
  color: #666666;
}
.color-99 {
  color: #999999;
}
.color-41CB8C {
  color: #41CB8C;
}
.color-43A4DF {
  color: #43A4DF;
}
.color-FE6670 {
  color: #FE6670;
}
.color-7795E6 {
  color: #7795E6;
}
.platformOnline {
  .institution-title {
    margin-top: 100px;
    text-align: center;
    img {
      height: 75px;
    }
  }
  .navigation {
    font-size: 16px;
    width: 1200px;
    margin: 50px auto 0px auto;
    border-bottom: 2px solid #E1E1E1;
    padding-bottom: 20px;
    span {
      cursor: pointer;
    }
  }
  .content {
    width: 1200px;
    margin: 30px auto;
    .content-title {
      height: 36px;
      font-size: 36px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgba(27, 27, 27, 1);
      line-height: 46px;
      text-align: center;
      padding: 40px 0 30px;
    }
    .show-items {
      .doc-item {
        display: inline-block;
        width: 585px;
        height: 140px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 0px 10px 0px rgba(208, 232, 242, 1);
        border-radius: 6px;
        font-size: 16px;
        margin-bottom: 30px;
        &:nth-child(2n + 1) {
          margin-right: 30px;
        }
        >div {
          float: left;
        }
        .doc-head {
          width: 100px;
          height: 100px;
          margin: 20px;
          img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
        }
        .doc-info {
          width: 245px;
          height: 140px;
          margin-top: 20px;
          span {
            line-height: 34px;
            margin-right: 16px;
          }
          .doc-name {
            span {
              // line-height: 32px;
              &:first-child {
                color: #333333;
                font-size: 20px;
                font-weight: bold;
              }
            }
          }
          >div:last-child {
            span {
              margin-right: 0;
            }
          }
        }
        .doc-data {
          float: right;
          min-width: 150px;
          margin-top: 22px;
          line-height: 34px;
          height: 140px;
          &:after {
            content: ' ';
            display: block;
            clear: both;
          }
        }
      }
      .page-list {
        .el-pagination {
          text-align: center;
          .el-icon-arrow-left:before, .el-icon-arrow-right:before {
            // color: #0080CB;
            background-color: #EEEEEE;
            display: inline-block;
            border-radius: 50%;
            width: 32px;
            height: 32px;
            line-height: 32px;
            text-align: center;
            font-size: 18px;
          }
          .el-pagination__total {
            height: 32px;
            line-height: 32px;
            color: #0080CB;
            font-size: 14px;
            margin-left: 20px;
          }
          .el-pager {
            li {
              border-radius: 50%;
              min-width: 32px;
              min-height: 32px;
              line-height: 32px;
              color: #0080CB;
              background-color: #EEEEEE;
              margin: 0 10px;
              &:not(.disabled).active {
                color: #fff;
                background-color: #0080CB;
              }
            }
          }
        }
      }
    }
  }
}
</style>
